// FeedbackFilter.js
import React from 'react';
import {
    Box,
    Grid,
    TextField,
    Slider,
    Button,
    Typography,
    CircularProgress,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Autocomplete
} from '@mui/material';
import DateRangePicker from './DateRangePicker';
import sectorsData from '../resources/sectors.json';
import companiesData from '../resources/companies.json';

const FeedbackFilter = ({
    filters,
    onFilterChange,
    onApplyFilters,
    isLoading,
    suggestionData,
    searchHistory,
    distributionData
}) => {
    const sectorOptions = distributionData?.Sector?.length > 0
        ? distributionData.Sector.map(item => item.attribute_value).filter(val => val !== null && val !== 'All')
        : (Array.isArray(sectorsData.distribution) ? sectorsData.distribution : sectorsData.distribution.distribution)
            .map(item => item.attribute_value)
            .filter(val => val !== null);

    const companyOptions = distributionData?.CompanyName?.length > 0
        ? distributionData.CompanyName.map(item => item.attribute_value).filter(val => val !== null && val !== 'All')
        : (Array.isArray(companiesData.distribution) ? companiesData.distribution : companiesData.distribution.distribution)
            .map(item => item.attribute_value)
            .filter(val => val !== null);

    return (
        <Box sx={{ borderRadius: 2, px: { xs: 1.5, sm: 2 }, pt: { xs: 0.5, sm: 1.25 } }}>
            <Grid container spacing={{ xs: 1.5, sm: 2, md: 3 }} sx={{ mb: 1 }} alignItems="center">
                {/* <Grid item xs={12} md={3} sx={{ mt: 2 }}>
                    <FormControl fullWidth>
                        <InputLabel id="attribute-label">Attribute</InputLabel>
                        <Select
                            labelId="attribute-label"
                            value={filters?.attribute || 'Sector'}
                            label="Attribute"
                            onChange={(e) => onFilterChange('attribute', e.target.value)}
                        >
                            <MenuItem value="Sector">Sector</MenuItem>
                            <MenuItem value="CompanyName">Company Name</MenuItem>
                            <MenuItem value="Category">Category</MenuItem>
                            <MenuItem value="userexperience">User Experience</MenuItem>
                        </Select>
                    </FormControl>
                </Grid> */}

                <Grid item xs={12} md={3} lg={3} sx={{ mt: { xs: 1, md: 2 } }}>
                    <Autocomplete
                        fullWidth
                        sx={{ width: '300px' }}
                        options={sectorOptions}
                        value={filters?.Sector || "All"}
                        onChange={(event, newValue) => onFilterChange('Sector', newValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Sector"
                                placeholder="e.g., Banking"
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} md={3} lg={3} sx={{ mt: { xs: 1, md: 2 } }}>
                    <Autocomplete
                        fullWidth
                        sx={{ width: '300px' }}
                        options={companyOptions}
                        value={filters?.CompanyName || "All"}
                        onChange={(event, newValue) => onFilterChange('CompanyName', newValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Company Name"
                                placeholder="e.g., HDFC Bank"
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4} sx={{ mt: { xs: 1, md: 2 } }}>
                    <DateRangePicker
                        value={{ startDate: filters?.startDate, endDate: filters?.endDate }}
                        onChange={(val) => {
                            if (val) {
                                onFilterChange('startDate', val.startDate ? new Date(val.startDate) : filters?.startDate);
                                onFilterChange('endDate', val.endDate ? new Date(val.endDate) : filters?.endDate);
                            }
                        }}
                    />
                </Grid>

                <Grid item xs={12} md={2} lg={2} sx={{ mt: { xs: 1, md: 2 }, display: 'flex', alignItems: 'center' }}>
                    <Button
                        variant="contained"
                        onClick={onApplyFilters}
                        disabled={isLoading}
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
                        sx={{
                            width: '200px',
                            height: '56px', // Match standard MUI TextField height
                            backgroundColor: 'rgba(94, 79, 170, 1)',
                            color: '#fff',
                            whiteSpace: 'nowrap',
                            '&:hover': {
                                backgroundColor: '#9B86FF',
                            }
                        }}
                    >
                        {isLoading
                            ? 'Loading...'
                            : 'Apply Filters'
                        }
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default FeedbackFilter;